import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { MenuItem, Select, Box } from '@mui/material';
import { Globe } from 'lucide-react';

const LanguageSwitcher = ({ isTransparent = false }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const languages = [
    { code: 'en', name: 'English', nativeName: 'English' },
    { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
  ];

  const handleLanguageChange = (langCode) => {
    // Get current path and extract the page path without language prefix
    const pathParts = location.pathname.split('/').filter(Boolean);

    // Check if first part is a language code
    const currentLangInPath = languages.find(lang => lang.code === pathParts[0]);
    const pagePath = currentLangInPath
      ? pathParts.slice(1).join('/')
      : pathParts.join('/');

    // Navigate to new language path
    const newPath = pagePath ? `/${langCode}/${pagePath}` : `/${langCode}`;
    navigate(newPath);

    // Change i18n language
    i18n.changeLanguage(langCode);
  };

  // Dynamic colors based on header transparency
  const iconColor = isTransparent ? '#FFFFFF' : '#D4A747';
  const borderColor = isTransparent ? 'rgba(255, 255, 255, 0.5)' : 'rgba(212, 167, 71, 0.3)';
  const hoverBorderColor = isTransparent ? '#FFFFFF' : '#D4A747';
  const textColor = isTransparent ? '#FFFFFF' : 'inherit';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Globe size={20} style={{ color: iconColor }} />
      <Select
        value={i18n.language}
        onChange={(e) => handleLanguageChange(e.target.value)}
        size="small"
        sx={{
          minWidth: 120,
          color: textColor,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: borderColor,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: hoverBorderColor,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: hoverBorderColor,
          },
          '& .MuiSvgIcon-root': {
            color: textColor,
          },
        }}
      >
        {languages.map(lang => (
          <MenuItem key={lang.code} value={lang.code}>
            {lang.nativeName}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default LanguageSwitcher;
